import React, { Component } from 'react';
import QRCodeLib from './qrcode';

import styles from './index.module.less';

import type { QRCodeErrorLevel, QRCodeRenderAs } from './helper';

export interface QRCodeProps {
  qrCodeValue: string,
  datasourceCustom: [],
  size?: number,
  bgColor?: string,
  fgColor?: string,
  level?: QRCodeErrorLevel,
  includeMargin?: boolean,
  imageSettings?: object,
  renderAs?: QRCodeRenderAs
}

export default class QRCode extends Component<QRCodeProps> {
  render () {
    const { fieldid, qrCodeValue = '', datasourceCustom = [], size = 64, bgColor = '#ffffff', level = 'L', includeMargin = false, imageSettings, renderAs = 'svg', visible = true, ...args } = this.props;
    const config = {
      qrCodeValue,
      datasourceCustom,
      size,
      bgColor,
      fgColor: this.props?.style?.color || '#000000',
      level,
      includeMargin,
      imageSettings: {},
      renderAs,
      ...args
    }
    const qrcodeSize = {
      width: size + 'px',
      height: size + 'px'
    }
    fieldid && (config.fieldid = fieldid)
    if (!visible) {
      return <div {...args}></div>
    }
    if (qrCodeValue === '') {
      return <div style={qrcodeSize} className={styles['lib-qrcode-empty']} {...args}></div>
    } else {
      config.value = qrCodeValue;
    }
    if (datasourceCustom.length > 0) {
      const key = datasourceCustom[1];
      config.value = args[key] || ''
    }
    return (<QRCodeLib {...config} />);
  }
}
